import { render, staticRenderFns } from "./productivity.vue?vue&type=template&id=58b9d80b&scoped=true&"
import script from "./productivity.vue?vue&type=script&lang=js&"
export * from "./productivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b9d80b",
  null
  
)

export default component.exports